import React, { useState } from 'react';

import { ModalVideoListVideo } from '../modal';
import { HelpDeskWrapper, ItemParagraph, ItemWrapper } from './index.styled';
import { getTranslatedItems } from './const';
import { HelpDeskTypes, IHelpDeskItem, ItemsTypes } from './utils';
import { useAuth } from 'lib/context';
import { WHITELABEL_NAME } from 'lib/api/whitelabel/getWhiteLabel';
import { Gap } from '../styles/layout';
import { useCDK } from 'lib/hooks/useCdk';
import { useTranslation } from 'react-i18next';

export const HelpDesk = ({ name }: { name: HelpDeskTypes }) => {
  const [modal, setModal] = useState({ show: false, url: '' });
  const { userData, whitelabel } = useAuth();
  const { isCdkUser } = useCDK();
  const { t } = useTranslation();

  const selectedItem = getTranslatedItems(t)?.[name];

  // Show placeholder for CDK users or invalid items or whitelabel not COVIDEO
  if (
    isCdkUser ||
    !selectedItem ||
    whitelabel?.name !== WHITELABEL_NAME.COVIDEO
  ) {
    return <div style={{ height: 83 }}></div>;
  }
  return (
    <HelpDeskWrapper name={name}>
      {selectedItem.map(
        ({ icon, title, url, type, id, automotiveUrl }: IHelpDeskItem) => {
          const videoUrl = userData.isAutomotive ? automotiveUrl : url;
          return (
            <ItemWrapper
              key={id}
              onClick={() =>
                type === ItemsTypes.LINK
                  ? window.open(url, '_blank', 'noopener, noreferrer')
                  : setModal({ show: true, url: videoUrl || url })
              }
            >
              <Gap className='icon-wrapper'>{icon}</Gap>
              <ItemParagraph>{title}</ItemParagraph>
            </ItemWrapper>
          );
        }
      )}
      {modal.show && (
        <ModalVideoListVideo
          videoId=''
          source={modal.url}
          handleModalClose={() => {
            setModal({ show: false, url: '' });
          }}
        />
      )}
    </HelpDeskWrapper>
  );
};
